'use client';

import CurrentStoreStockIcon from '@components/InternalIcons/Icons/StockIcons/CurrentStoreStockIcon';
import OnlineStockIcon from '@components/InternalIcons/Icons/StockIcons/OnlineStockIcon';
import StockInOtherLocationsIcon from '@components/InternalIcons/Icons/StockIcons/StockInOtherLocationsIcon';
import { getStockUrl } from '@components/InternalIcons/utils/getIconsUrls';
import { getStockData } from '@features/internal-icons/api/actions';
import { AvailableProductStockLevelsForStore } from '@features/internal-icons/typings/AvailableProductStockLevelsForStore';
import { AvailableProductStockLevelsForWebshop } from '@features/internal-icons/typings/AvailableProductStockLevelsForWebshop';
import { ReactElement, useEffect, useState } from 'react';

type Props = {
  productId: number;
  totalIndices: number;
  storeEmployee: boolean;
};

export const StockIcons = ({ productId, totalIndices, storeEmployee }: Props): ReactElement => {
  const stockUrl = getStockUrl(productId);
  const [stockLevels, setStockLevels] = useState<
    AvailableProductStockLevelsForStore | AvailableProductStockLevelsForWebshop | null
  >(null);

  useEffect(() => {
    if (!productId) return;

    const fetchStockData = async () => {
      const stockLevels = await getStockData(productId);
      setStockLevels(stockLevels);
    };
    fetchStockData().catch(console.error);
  }, [productId]);

  if (!stockUrl) return <></>;

  return storeEmployee ? (
    <>
      <CurrentStoreStockIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForStore)?.availableProductStockLevelInStore
        }
        url={stockUrl.href}
        index={5}
        totalIndices={totalIndices}
      />
      <OnlineStockIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForStore)?.availableProductStockLevelWebshop
        }
        url={stockUrl.href}
        index={6}
        totalIndices={totalIndices}
      />
      <StockInOtherLocationsIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForStore)
            ?.availableProductStockLevelOtherStores
        }
        url={stockUrl.href}
        index={7}
        totalIndices={totalIndices}
      />
    </>
  ) : (
    <>
      <OnlineStockIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForWebshop)?.availableProductStockLevelWebshop
        }
        url={stockUrl.href}
        index={5}
        totalIndices={totalIndices}
      />
      <StockInOtherLocationsIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForWebshop)?.availableProductStockLevelStores
        }
        url={stockUrl.href}
        index={6}
        totalIndices={totalIndices}
      />
    </>
  );
};

export default StockIcons;
